import { render } from "./UserManager.vue?vue&type=template&id=7f9aba3d&scoped=true"
import script from "./UserManager.vue?vue&type=script&lang=js"
export * from "./UserManager.vue?vue&type=script&lang=js"

import "./UserManager.vue?vue&type=style&index=0&id=7f9aba3d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9aba3d"]])

export default __exports__